

import unkwnown from './logos/default.png';
import logo0B from './logos/0B.png';
import logo0E from './logos/0E.png';
import logo0Q from './logos/0Q.png';
import logo0V from './logos/0V.png';
import logo01 from './logos/01.png';
import logo1A from './logos/1A.png';
import logo1B from './logos/1B.png';
import logo1C from './logos/1C.png';
import logo1D from './logos/1D.png';
import logo1E from './logos/1E.png';
import logo1F from './logos/1F.png';
import logo1G from './logos/1G.png';
import logo1H from './logos/1H.png';
import logo1I from './logos/1I.png';
import logo1J from './logos/1J.png';
import logo1K from './logos/1K.png';
import logo1L from './logos/1L.png';
import logo1M from './logos/1M.png';
import logo1N from './logos/1N.png';
import logo1P from './logos/1P.png';
import logo1Q from './logos/1Q.png';
import logo1R from './logos/1R.png';
import logo1S from './logos/1S.png';
import logo1T from './logos/1T.png';
import logo1U from './logos/1U.png';
import logo1X from './logos/1X.png';
import logo1Y from './logos/1Y.png';
import logo1Z from './logos/1Z.png';
import logo02 from './logos/02.png';
import logo2A from './logos/2A.png';
import logo2B from './logos/2B.png';
import logo2C from './logos/2C.png';
import logo2D from './logos/2D.png';
import logo2E from './logos/2E.png';
import logo2F from './logos/2F.png';
import logo2G from './logos/2G.png';
import logo2H from './logos/2H.png';
import logo2I from './logos/2I.png';
import logo2J from './logos/2J.png';
import logo2K from './logos/2K.png';
import logo2L from './logos/2L.png';
import logo2M from './logos/2M.png';
import logo2N from './logos/2N.png';
import logo2O from './logos/2O.png';
import logo2P from './logos/2P.png';
import logo2Q from './logos/2Q.png';
import logo2R from './logos/2R.png';
import logo2S from './logos/2S.png';
import logo2T from './logos/2T.png';
import logo2U from './logos/2U.png';
import logo2V from './logos/2V.png';
import logo2W from './logos/2W.png';
import logo2Y from './logos/2Y.png';
import logo2Z from './logos/2Z.png';
import logo3A from './logos/3A.png';
import logo3B from './logos/3B.png';
import logo3C from './logos/3C.png';
import logo3D from './logos/3D.png';
import logo3E from './logos/3E.png';
import logo3F from './logos/3F.png';
import logo3G from './logos/3G.png';
import logo3H from './logos/3H.png';
import logo3I from './logos/3I.png';
import logo3J from './logos/3J.png';
import logo3K from './logos/3K.png';
import logo3L from './logos/3L.png';
import logo3M from './logos/3M.png';
import logo3N from './logos/3N.png';
import logo3O from './logos/3O.png';
import logo3P from './logos/3P.png';
import logo3Q from './logos/3Q.png';
import logo3R from './logos/3R.png';
import logo3S from './logos/3S.png';
import logo3T from './logos/3T.png';
import logo3U from './logos/3U.png';
import logo3V from './logos/3V.png';
import logo3W from './logos/3W.png';
import logo3X from './logos/3X.png';
import logo3Y from './logos/3Y.png';
import logo3Z from './logos/3Z.png';
import logo04 from './logos/04.png';
import logo4A from './logos/4A.png';
import logo4B from './logos/4B.png';
import logo4C from './logos/4C.png';
import logo4D from './logos/4D.png';
import logo4E from './logos/4E.png';
import logo4G from './logos/4G.png';
import logo4H from './logos/4H.png';
import logo4I from './logos/4I.png';
import logo4J from './logos/4J.png';
import logo4K from './logos/4K.png';
import logo4L from './logos/4L.png';
import logo4M from './logos/4M.png';
import logo4N from './logos/4N.png';
import logo4O from './logos/4O.png';
import logo4P from './logos/4P.png';
import logo4Q from './logos/4Q.png';
import logo4R from './logos/4R.png';
import logo4T from './logos/4T.png';
import logo4U from './logos/4U.png';
import logo4V from './logos/4V.png';
import logo4W from './logos/4W.png';
import logo4X from './logos/4X.png';
import logo4Y from './logos/4Y.png';
import logo4Z from './logos/4Z.png';
import logo5A from './logos/5A.png';
import logo5B from './logos/5B.png';
import logo5C from './logos/5C.png';
import logo5D from './logos/5D.png';
import logo5E from './logos/5E.png';
import logo5F from './logos/5F.png';
import logo5G from './logos/5G.png';
import logo5H from './logos/5H.png';
import logo5I from './logos/5I.png';
import logo5J from './logos/5J.png';
import logo5K from './logos/5K.png';
import logo5L from './logos/5L.png';
import logo5M from './logos/5M.png';
import logo5N from './logos/5N.png';
import logo5O from './logos/5O.png';
import logo5P from './logos/5P.png';
import logo5Q from './logos/5Q.png';
import logo5R from './logos/5R.png';
import logo5S from './logos/5S.png';
import logo5T from './logos/5T.png';
import logo5U from './logos/5U.png';
import logo5V from './logos/5V.png';
import logo5W from './logos/5W.png';
import logo5X from './logos/5X.png';
import logo5Y from './logos/5Y.png';
import logo5Z from './logos/5Z.png';
import logo6A from './logos/6A.png';
import logo6B from './logos/6B.png';
import logo6C from './logos/6C.png';
import logo6D from './logos/6D.png';
import logo6E from './logos/6E.png';
import logo6F from './logos/6F.png';
import logo6G from './logos/6G.png';
import logo6H from './logos/6H.png';
import logo6I from './logos/6I.png';
import logo6J from './logos/6J.png';
import logo6K from './logos/6K.png';
import logo6L from './logos/6L.png';
import logo6M from './logos/6M.png';
import logo6N from './logos/6N.png';
import logo6O from './logos/6O.png';
import logo6P from './logos/6P.png';
import logo6Q from './logos/6Q.png';
import logo6R from './logos/6R.png';
import logo6S from './logos/6S.png';
import logo6T from './logos/6T.png';
import logo6U from './logos/6U.png';
import logo6V from './logos/6V.png';
import logo6W from './logos/6W.png';
import logo6X from './logos/6X.png';
import logo6Y from './logos/6Y.png';
import logo6Z from './logos/6Z.png';
import logo7A from './logos/7A.png';
import logo7B from './logos/7B.png';
import logo7C from './logos/7C.png';
import logo7D from './logos/7D.png';
import logo7E from './logos/7E.png';
import logo7F from './logos/7F.png';
import logo7G from './logos/7G.png';
import logo7H from './logos/7H.png';
import logo7I from './logos/7I.png';
import logo7J from './logos/7J.png';
import logo7K from './logos/7K.png';
import logo7L from './logos/7L.png';
import logo7M from './logos/7M.png';
import logo7N from './logos/7N.png';
import logo7O from './logos/7O.png';
import logo7P from './logos/7P.png';
import logo7Q from './logos/7Q.png';
import logo7R from './logos/7R.png';
import logo7T from './logos/7T.png';
import logo7U from './logos/7U.png';
import logo7V from './logos/7V.png';
import logo7W from './logos/7W.png';
import logo7Y from './logos/7Y.png';
import logo7Z from './logos/7Z.png';
import logo8A from './logos/8A.png';
import logo8B from './logos/8B.png';
import logo8C from './logos/8C.png';
import logo8D from './logos/8D.png';
import logo8E from './logos/8E.png';
import logo8F from './logos/8F.png';
import logo8G from './logos/8G.png';
import logo8H from './logos/8H.png';
import logo8I from './logos/8I.png';
import logo8J from './logos/8J.png';
import logo8K from './logos/8K.png';
import logo8L from './logos/8L.png';
import logo8M from './logos/8M.png';
import logo8N from './logos/8N.png';
import logo8O from './logos/8O.png';
import logo8P from './logos/8P.png';
import logo8Q from './logos/8Q.png';
import logo8R from './logos/8R.png';
import logo8S from './logos/8S.png';
import logo8T from './logos/8T.png';
import logo8U from './logos/8U.png';
import logo8V from './logos/8V.png';
import logo8W from './logos/8W.png';
import logo8Y from './logos/8Y.png';
import logo8Z from './logos/8Z.png';
import logo9A from './logos/9A.png';
import logo9B from './logos/9B.png';
import logo9C from './logos/9C.png';
import logo9D from './logos/9D.png';
import logo9E from './logos/9E.png';
import logo9F from './logos/9F.png';
import logo9G from './logos/9G.png';
import logo9H from './logos/9H.png';
import logo9I from './logos/9I.png';
import logo9J from './logos/9J.png';
import logo9K from './logos/9K.png';
import logo9L from './logos/9L.png';
import logo9M from './logos/9M.png';
import logo9N from './logos/9N.png';
import logo9O from './logos/9O.png';
import logo9P from './logos/9P.png';
import logo9Q from './logos/9Q.png';
import logo9R from './logos/9R.png';
import logo9S from './logos/9S.png';
import logo9T from './logos/9T.png';
import logo9U from './logos/9U.png';
import logo9V from './logos/9V.png';
import logo9W from './logos/9W.png';
import logo9X from './logos/9X.png';
import logo9Y from './logos/9Y.png';
import logoA0 from './logos/A0.png';
import logoA1 from './logos/A1.png';
import logoA2 from './logos/A2.png';
import logoA3 from './logos/A3.png';
import logoA4 from './logos/A4.png';
import logoA5 from './logos/A5.png';
import logoA6 from './logos/A6.png';
import logoA7 from './logos/A7.png';
import logoA8 from './logos/A8.png';
import logoA9 from './logos/A9.png';
import logoAA from './logos/AA.png';
import logoAB from './logos/AB.png';
import logoAC from './logos/AC.png';
import logoAD from './logos/AD.png';
import logoAE from './logos/AE.png';
import logoAF from './logos/AF.png';
import logoAG from './logos/AG.png';
import logoAH from './logos/AH.png';
import logoAI from './logos/AI.png';
import logoAJ from './logos/AJ.png';
import logoAK from './logos/AK.png';
import logoAL from './logos/AL.png';
import logoAM from './logos/AM.png';
import logoAN from './logos/AN.png';
import logoAO from './logos/AO.png';
import logoAP from './logos/AP.png';
import logoAQ from './logos/AQ.png';
import logoAR from './logos/AR.png';
import logoAS from './logos/AS.png';
import logoAT from './logos/AT.png';
import logoAU from './logos/AU.png';
import logoAV from './logos/AV.png';
import logoAW from './logos/AW.png';
import logoAX from './logos/AX.png';
import logoAY from './logos/AY.png';
import logoAZ from './logos/AZ.png';
import logoB0 from './logos/B0.png';
import logoB2 from './logos/B2.png';
import logoB3 from './logos/B3.png';
import logoB4 from './logos/B4.png';
import logoB5 from './logos/B5.png';
import logoB6 from './logos/B6.png';
import logoB7 from './logos/B7.png';
import logoB8 from './logos/B8.png';
import logoB9 from './logos/B9.png';
import logoBA from './logos/BA.png';
import logoBB from './logos/BB.png';
import logoBC from './logos/BC.png';
import logoBD from './logos/BD.png';
import logoBE from './logos/BE.png';
import logoBF from './logos/BF.png';
import logoBG from './logos/BG.png';
import logoBH from './logos/BH.png';
import logoBI from './logos/BI.png';
import logoBJ from './logos/BJ.png';
import logoBK from './logos/BK.png';
import logoBL from './logos/BL.png';
import logoBM from './logos/BM.png';
import logoBN from './logos/BN.png';
import logoBO from './logos/BO.png';
import logoBP from './logos/BP.png';
import logoBQ from './logos/BQ.png';
import logoBR from './logos/BR.png';
import logoBS from './logos/BS.png';
import logoBT from './logos/BT.png';
import logoBU from './logos/BU.png';
import logoBV from './logos/BV.png';
import logoBW from './logos/BW.png';
import logoBX from './logos/BX.png';
import logoBY from './logos/BY.png';
import logoBZ from './logos/BZ.png';
import logoC0 from './logos/C0.png';
import logoC2 from './logos/C2.png';
import logoC3 from './logos/C3.png';
import logoC4 from './logos/C4.png';
import logoC5 from './logos/C5.png';
import logoC6 from './logos/C6.png';
import logoC7 from './logos/C7.png';
import logoC8 from './logos/C8.png';
import logoC9 from './logos/C9.png';
import logoCA from './logos/CA.png';
import logoCB from './logos/CB.png';
import logoCC from './logos/CC.png';
import logoCD from './logos/CD.png';
import logoCE from './logos/CE.png';
import logoCF from './logos/CF.png';
import logoCG from './logos/CG.png';
import logoCH from './logos/CH.png';
import logoCI from './logos/CI.png';
import logoCJ from './logos/CJ.png';
import logoCK from './logos/CK.png';
import logoCL from './logos/CL.png';
import logoCM from './logos/CM.png';
import logoCN from './logos/CN.png';
import logoCO from './logos/CO.png';
import logoCP from './logos/CP.png';
import logoCQ from './logos/CQ.png';
import logoCR from './logos/CR.png';
import logoCS from './logos/CS.png';
import logoCT from './logos/CT.png';
import logoCU from './logos/CU.png';
import logoCV from './logos/CV.png';
import logoCW from './logos/CW.png';
import logoCX from './logos/CX.png';
import logoCY from './logos/CY.png';
import logoCZ from './logos/CZ.png';
import logoD0 from './logos/D0.png';
import logoD1 from './logos/D1.png';
import logoD2 from './logos/D2.png';
import logoD3 from './logos/D3.png';
import logoD4 from './logos/D4.png';
import logoD5 from './logos/D5.png';
import logoD6 from './logos/D6.png';
import logoD7 from './logos/D7.png';
import logoD8 from './logos/D8.png';
import logoD9 from './logos/D9.png';
import logoDA from './logos/DA.png';
import logoDB from './logos/DB.png';
import logoDC from './logos/DC.png';
import logoDD from './logos/DD.png';
import logoDE from './logos/DE.png';
import logoDF from './logos/DF.png';
import logoDG from './logos/DG.png';
import logoDH from './logos/DH.png';
import logoDI from './logos/DI.png';
import logoDJ from './logos/DJ.png';
import logoDK from './logos/DK.png';
import logoDL from './logos/DL.png';
import logoDM from './logos/DM.png';
import logoDN from './logos/DN.png';
import logoDO from './logos/DO.png';
import logoDP from './logos/DP.png';
import logoDQ from './logos/DQ.png';
import logoDR from './logos/DR.png';
import logoDS from './logos/DS.png';
import logoDT from './logos/DT.png';
import logoDU from './logos/DU.png';
import logoDV from './logos/DV.png';
import logoDW from './logos/DW.png';
import logoDX from './logos/DX.png';
import logoDY from './logos/DY.png';
import logoDZ from './logos/DZ.png';
import logoE0 from './logos/E0.png';
import logoE2 from './logos/E2.png';
import logoE3 from './logos/E3.png';
import logoE4 from './logos/E4.png';
import logoE5 from './logos/E5.png';
import logoE6 from './logos/E6.png';
import logoE7 from './logos/E7.png';
import logoE8 from './logos/E8.png';
import logoE9 from './logos/E9.png';
import logoEA from './logos/EA.png';
import logoEB from './logos/EB.png';
import logoEC from './logos/EC.png';
import logoED from './logos/ED.png';
import logoEE from './logos/EE.png';
import logoEF from './logos/EF.png';
import logoEG from './logos/EG.png';
import logoEH from './logos/EH.png';
import logoEI from './logos/EI.png';
import logoEJ from './logos/EJ.png';
import logoEK from './logos/EK.png';
import logoEL from './logos/EL.png';
import logoEM from './logos/EM.png';
import logoEN from './logos/EN.png';
import logoEO from './logos/EO.png';
import logoEP from './logos/EP.png';
import logoEQ from './logos/EQ.png';
import logoER from './logos/ER.png';
import logoES from './logos/ES.png';
import logoET from './logos/ET.png';
import logoEU from './logos/EU.png';
import logoEV from './logos/EV.png';
import logoEW from './logos/EW.png';
import logoEX from './logos/EX.png';
import logoEY from './logos/EY.png';
import logoEZ from './logos/EZ.png';
import logoF2 from './logos/F2.png';
import logoF3 from './logos/F3.png';
import logoF4 from './logos/F4.png';
import logoF5 from './logos/F5.png';
import logoF6 from './logos/F6.png';
import logoF7 from './logos/F7.png';
import logoF8 from './logos/F8.png';
import logoF9 from './logos/F9.png';
import logoFA from './logos/FA.png';
import logoFB from './logos/FB.png';
import logoFC from './logos/FC.png';
import logoFD from './logos/FD.png';
import logoFE from './logos/FE.png';
import logoFG from './logos/FG.png';
import logoFH from './logos/FH.png';
import logoFI from './logos/FI.png';
import logoFJ from './logos/FJ.png';
import logoFK from './logos/FK.png';
import logoFL from './logos/FL.png';
import logoFM from './logos/FM.png';
import logoFN from './logos/FN.png';
import logoFO from './logos/FO.png';
import logoFP from './logos/FP.png';
import logoFQ from './logos/FQ.png';
import logoFR from './logos/FR.png';
import logoFS from './logos/FS.png';
import logoFT from './logos/FT.png';
import logoFU from './logos/FU.png';
import logoFV from './logos/FV.png';
import logoFW from './logos/FW.png';
import logoFX from './logos/FX.png';
import logoFY from './logos/FY.png';
import logoFZ from './logos/FZ.png';
import logoG0 from './logos/G0.png';
import logoG1 from './logos/G1.png';
import logoG2 from './logos/G2.png';
import logoG3 from './logos/G3.png';
import logoG4 from './logos/G4.png';
import logoG5 from './logos/G5.png';
import logoG6 from './logos/G6.png';
import logoG7 from './logos/G7.png';
import logoG8 from './logos/G8.png';
import logoG9 from './logos/G9.png';
import logoGA from './logos/GA.png';
import logoGB from './logos/GB.png';
import logoGC from './logos/GC.png';
import logoGD from './logos/GD.png';
import logoGE from './logos/GE.png';
import logoGF from './logos/GF.png';
import logoGG from './logos/GG.png';
import logoGH from './logos/GH.png';
import logoGI from './logos/GI.png';
import logoGJ from './logos/GJ.png';
import logoGK from './logos/GK.png';
import logoGL from './logos/GL.png';
import logoGM from './logos/GM.png';
import logoGN from './logos/GN.png';
import logoGO from './logos/GO.png';
import logoGP from './logos/GP.png';
import logoGQ from './logos/GQ.png';
import logoGR from './logos/GR.png';
import logoGS from './logos/GS.png';
import logoGT from './logos/GT.png';
import logoGU from './logos/GU.png';
import logoGV from './logos/GV.png';
import logoGW from './logos/GW.png';
import logoGX from './logos/GX.png';
import logoGY from './logos/GY.png';
import logoGZ from './logos/GZ.png';
import logoH1 from './logos/H1.png';
import logoH2 from './logos/H2.png';
import logoH3 from './logos/H3.png';
import logoH4 from './logos/H4.png';
import logoH5 from './logos/H5.png';
import logoH6 from './logos/H6.png';
import logoH7 from './logos/H7.png';
import logoH8 from './logos/H8.png';
import logoH9 from './logos/H9.png';
import logoHA from './logos/HA.png';
import logoHB from './logos/HB.png';
import logoHC from './logos/HC.png';
import logoHD from './logos/HD.png';
import logoHE from './logos/HE.png';
import logoHF from './logos/HF.png';
import logoHG from './logos/HG.png';
import logoHH from './logos/HH.png';
import logoHI from './logos/HI.png';
import logoHJ from './logos/HJ.png';
import logoHK from './logos/HK.png';
import logoHM from './logos/HM.png';
import logoHN from './logos/HN.png';
import logoHO from './logos/HO.png';
import logoHP from './logos/HP.png';
import logoHQ from './logos/HQ.png';
import logoHR from './logos/HR.png';
import logoHS from './logos/HS.png';
import logoHT from './logos/HT.png';
import logoHU from './logos/HU.png';
import logoHV from './logos/HV.png';
import logoHW from './logos/HW.png';
import logoHX from './logos/HX.png';
import logoHY from './logos/HY.png';
import logoHZ from './logos/HZ.png';
import logoI1 from './logos/I1.png';
import logoI2 from './logos/I2.png';
import logoI3 from './logos/I3.png';
import logoI4 from './logos/I4.png';
import logoI5 from './logos/I5.png';
import logoI6 from './logos/I6.png';
import logoI7 from './logos/I7.png';
import logoI8 from './logos/I8.png';
import logoI9 from './logos/I9.png';
import logoIA from './logos/IA.png';
import logoIB from './logos/IB.png';
import logoIC from './logos/IC.png';
import logoID from './logos/ID.png';
import logoIE from './logos/IE.png';
import logoIF from './logos/IF.png';
import logoIG from './logos/IG.png';
import logoIH from './logos/IH.png';
import logoII from './logos/II.png';
import logoIJ from './logos/IJ.png';
import logoIK from './logos/IK.png';
import logoIL from './logos/IL.png';
import logoIM from './logos/IM.png';
import logoIN from './logos/IN.png';
import logoIO from './logos/IO.png';
import logoIP from './logos/IP.png';
import logoIQ from './logos/IQ.png';
import logoIR from './logos/IR.png';
import logoIS from './logos/IS.png';
import logoIT from './logos/IT.png';
import logoIU from './logos/IU.png';
import logoIV from './logos/IV.png';
import logoIW from './logos/IW.png';
import logoIX from './logos/IX.png';
import logoIY from './logos/IY.png';
import logoIZ from './logos/IZ.png';
import logoJ0 from './logos/J0.png';
import logoJ1 from './logos/J1.png';
import logoJ2 from './logos/J2.png';
import logoJ3 from './logos/J3.png';
import logoJ4 from './logos/J4.png';
import logoJ5 from './logos/J5.png';
import logoJ6 from './logos/J6.png';
import logoJ7 from './logos/J7.png';
import logoJ8 from './logos/J8.png';
import logoJ9 from './logos/J9.png';
import logoJA from './logos/JA.png';
import logoJB from './logos/JB.png';
import logoJC from './logos/JC.png';
import logoJD from './logos/JD.png';
import logoJE from './logos/JE.png';
import logoJF from './logos/JF.png';
import logoJG from './logos/JG.png';
import logoJH from './logos/JH.png';
import logoJI from './logos/JI.png';
import logoJJ from './logos/JJ.png';
import logoJK from './logos/JK.png';
import logoJL from './logos/JL.png';
import logoJM from './logos/JM.png';
import logoJN from './logos/JN.png';
import logoJO from './logos/JO.png';
import logoJP from './logos/JP.png';
import logoJQ from './logos/JQ.png';
import logoJR from './logos/JR.png';
import logoJS from './logos/JS.png';
import logoJT from './logos/JT.png';
import logoJU from './logos/JU.png';
import logoJV from './logos/JV.png';
import logoJW from './logos/JW.png';
import logoJX from './logos/JX.png';
import logoJY from './logos/JY.png';
import logoJZ from './logos/JZ.png';
import logoK1 from './logos/K1.png';
import logoK2 from './logos/K2.png';
import logoK3 from './logos/K3.png';
import logoK4 from './logos/K4.png';
import logoK5 from './logos/K5.png';
import logoK6 from './logos/K6.png';
import logoK7 from './logos/K7.png';
import logoK8 from './logos/K8.png';
import logoK9 from './logos/K9.png';
import logoKA from './logos/KA.png';
import logoKB from './logos/KB.png';
import logoKC from './logos/KC.png';
import logoKD from './logos/KD.png';
import logoKE from './logos/KE.png';
import logoKF from './logos/KF.png';
import logoKG from './logos/KG.png';
import logoKH from './logos/KH.png';
import logoKI from './logos/KI.png';
import logoKJ from './logos/KJ.png';
import logoKK from './logos/KK.png';
import logoKL from './logos/KL.png';
import logoKM from './logos/KM.png';
import logoKN from './logos/KN.png';
import logoKO from './logos/KO.png';
import logoKP from './logos/KP.png';
import logoKQ from './logos/KQ.png';
import logoKR from './logos/KR.png';
import logoKS from './logos/KS.png';
import logoKT from './logos/KT.png';
import logoKU from './logos/KU.png';
import logoKV from './logos/KV.png';
import logoKW from './logos/KW.png';
import logoKX from './logos/KX.png';
import logoKY from './logos/KY.png';
import logoKZ from './logos/KZ.png';
import logoL2 from './logos/L2.png';
import logoL3 from './logos/L3.png';
import logoL4 from './logos/L4.png';
import logoL5 from './logos/L5.png';
import logoL6 from './logos/L6.png';
import logoL7 from './logos/L7.png';
import logoL8 from './logos/L8.png';
import logoL9 from './logos/L9.png';
import logoLA from './logos/LA.png';
import logoLB from './logos/LB.png';
import logoLC from './logos/LC.png';
import logoLD from './logos/LD.png';
import logoLE from './logos/LE.png';
import logoLF from './logos/LF.png';
import logoLG from './logos/LG.png';
import logoLH from './logos/LH.png';
import logoLI from './logos/LI.png';
import logoLJ from './logos/LJ.png';
import logoLK from './logos/LK.png';
import logoLL from './logos/LL.png';
import logoLM from './logos/LM.png';
import logoLN from './logos/LN.png';
import logoLO from './logos/LO.png';
import logoLP from './logos/LP.png';
import logoLQ from './logos/LQ.png';
import logoLR from './logos/LR.png';
import logoLS from './logos/LS.png';
import logoLT from './logos/LT.png';
import logoLU from './logos/LU.png';
import logoLV from './logos/LV.png';
import logoLW from './logos/LW.png';
import logoLX from './logos/LX.png';
import logoLY from './logos/LY.png';
import logoLZ from './logos/LZ.png';
import logoM0 from './logos/M0.png';
import logoM2 from './logos/M2.png';
import logoM3 from './logos/M3.png';
import logoM4 from './logos/M4.png';
import logoM5 from './logos/M5.png';
import logoM6 from './logos/M6.png';
import logoM7 from './logos/M7.png';
import logoM8 from './logos/M8.png';
import logoM9 from './logos/M9.png';
import logoMA from './logos/MA.png';
import logoMB from './logos/MB.png';
import logoMC from './logos/MC.png';
import logoMD from './logos/MD.png';
import logoME from './logos/ME.png';
import logoMF from './logos/MF.png';
import logoMG from './logos/MG.png';
import logoMH from './logos/MH.png';
import logoMI from './logos/MI.png';
import logoMJ from './logos/MJ.png';
import logoMK from './logos/MK.png';
import logoML from './logos/ML.png';
import logoMM from './logos/MM.png';
import logoMN from './logos/MN.png';
import logoMO from './logos/MO.png';
import logoMP from './logos/MP.png';
import logoMQ from './logos/MQ.png';
import logoMR from './logos/MR.png';
import logoMS from './logos/MS.png';
import logoMT from './logos/MT.png';
import logoMU from './logos/MU.png';
import logoMV from './logos/MV.png';
import logoMW from './logos/MW.png';
import logoMX from './logos/MX.png';
import logoMY from './logos/MY.png';
import logoMZ from './logos/MZ.png';
import logoN2 from './logos/N2.png';
import logoN3 from './logos/N3.png';
import logoN4 from './logos/N4.png';
import logoN5 from './logos/N5.png';
import logoN6 from './logos/N6.png';
import logoN7 from './logos/N7.png';
import logoN8 from './logos/N8.png';
import logoN9 from './logos/N9.png';
import logoNA from './logos/NA.png';
import logoNB from './logos/NB.png';
import logoNC from './logos/NC.png';
import logoNE from './logos/NE.png';
import logoNF from './logos/NF.png';
import logoNG from './logos/NG.png';
import logoNH from './logos/NH.png';
import logoNI from './logos/NI.png';
import logoNK from './logos/NK.png';
import logoNL from './logos/NL.png';
import logoNM from './logos/NM.png';
import logoNN from './logos/NN.png';
import logoNO from './logos/NO.png';
import logoNP from './logos/NP.png';
import logoNQ from './logos/NQ.png';
import logoNR from './logos/NR.png';
import logoNS from './logos/NS.png';
import logoNT from './logos/NT.png';
import logoNU from './logos/NU.png';
import logoNV from './logos/NV.png';
import logoNW from './logos/NW.png';
import logoNX from './logos/NX.png';
import logoNY from './logos/NY.png';
import logoNZ from './logos/NZ.png';
import logoO2 from './logos/O2.png';
import logoO3 from './logos/O3.png';
import logoO4 from './logos/O4.png';
import logoO5 from './logos/O5.png';
import logoO6 from './logos/O6.png';
import logoO7 from './logos/O7.png';
import logoO8 from './logos/O8.png';
import logoO9 from './logos/O9.png';
import logoOA from './logos/OA.png';
import logoOB from './logos/OB.png';
import logoOC from './logos/OC.png';
import logoOD from './logos/OD.png';
import logoOE from './logos/OE.png';
import logoOF from './logos/OF.png';
import logoOG from './logos/OG.png';
import logoOH from './logos/OH.png';
import logoOI from './logos/OI.png';
import logoOJ from './logos/OJ.png';
import logoOK from './logos/OK.png';
import logoOL from './logos/OL.png';
import logoOM from './logos/OM.png';
import logoON from './logos/ON.png';
import logoOO from './logos/OO.png';
import logoOP from './logos/OP.png';
import logoOQ from './logos/OQ.png';
import logoOR from './logos/OR.png';
import logoOS from './logos/OS.png';
import logoOT from './logos/OT.png';
import logoOU from './logos/OU.png';
import logoOV from './logos/OV.png';
import logoOW from './logos/OW.png';
import logoOX from './logos/OX.png';
import logoOY from './logos/OY.png';
import logoOZ from './logos/OZ.png';
import logoP0 from './logos/P0.png';
import logoP1 from './logos/P1.png';
import logoP2 from './logos/P2.png';
import logoP3 from './logos/P3.png';
import logoP4 from './logos/P4.png';
import logoP5 from './logos/P5.png';
import logoP6 from './logos/P6.png';
import logoP7 from './logos/P7.png';
import logoP8 from './logos/P8.png';
import logoP9 from './logos/P9.png';
import logoPA from './logos/PA.png';
import logoPB from './logos/PB.png';
import logoPC from './logos/PC.png';
import logoPD from './logos/PD.png';
import logoPE from './logos/PE.png';
import logoPF from './logos/PF.png';
import logoPG from './logos/PG.png';
import logoPH from './logos/PH.png';
import logoPI from './logos/PI.png';
import logoPJ from './logos/PJ.png';
import logoPK from './logos/PK.png';
import logoPL from './logos/PL.png';
import logoPM from './logos/PM.png';
import logoPN from './logos/PN.png';
import logoPO from './logos/PO.png';
import logoPP from './logos/PP.png';
import logoPQ from './logos/PQ.png';
import logoPR from './logos/PR.png';
import logoPS from './logos/PS.png';
import logoPT from './logos/PT.png';
import logoPU from './logos/PU.png';
import logoPV from './logos/PV.png';
import logoPW from './logos/PW.png';
import logoPX from './logos/PX.png';
import logoPY from './logos/PY.png';
import logoPZ from './logos/PZ.png';
import logoQ0 from './logos/Q0.png';
import logoQ2 from './logos/Q2.png';
import logoQ3 from './logos/Q3.png';
import logoQ4 from './logos/Q4.png';
import logoQ5 from './logos/Q5.png';
import logoQ6 from './logos/Q6.png';
import logoQ7 from './logos/Q7.png';
import logoQ8 from './logos/Q8.png';
import logoQ9 from './logos/Q9.png';
import logoQA from './logos/QA.png';
import logoQB from './logos/QB.png';
import logoQC from './logos/QC.png';
import logoQD from './logos/QD.png';
import logoQE from './logos/QE.png';
import logoQF from './logos/QF.png';
import logoQG from './logos/QG.png';
import logoQH from './logos/QH.png';
import logoQI from './logos/QI.png';
import logoQJ from './logos/QJ.png';
import logoQK from './logos/QK.png';
import logoQL from './logos/QL.png';
import logoQM from './logos/QM.png';
import logoQN from './logos/QN.png';
import logoQO from './logos/QO.png';
import logoQP from './logos/QP.png';
import logoQQ from './logos/QQ.png';
import logoQR from './logos/QR.png';
import logoQS from './logos/QS.png';
import logoQT from './logos/QT.png';
import logoQU from './logos/QU.png';
import logoQV from './logos/QV.png';
import logoQW from './logos/QW.png';
import logoQX from './logos/QX.png';
import logoQY from './logos/QY.png';
import logoQZ from './logos/QZ.png';
import logoR0 from './logos/R0.png';
import logoR1 from './logos/R1.png';
import logoR2 from './logos/R2.png';
import logoR3 from './logos/R3.png';
import logoR4 from './logos/R4.png';
import logoR5 from './logos/R5.png';
import logoR6 from './logos/R6.png';
import logoR7 from './logos/R7.png';
import logoR8 from './logos/R8.png';
import logoR9 from './logos/R9.png';
import logoRA from './logos/RA.png';
import logoRB from './logos/RB.png';
import logoRC from './logos/RC.png';
import logoRD from './logos/RD.png';
import logoRE from './logos/RE.png';
import logoRF from './logos/RF.png';
import logoRG from './logos/RG.png';
import logoRH from './logos/RH.png';
import logoRI from './logos/RI.png';
import logoRJ from './logos/RJ.png';
import logoRK from './logos/RK.png';
import logoRL from './logos/RL.png';
import logoRN from './logos/RN.png';
import logoRO from './logos/RO.png';
import logoRP from './logos/RP.png';
import logoRQ from './logos/RQ.png';
import logoRR from './logos/RR.png';
import logoRS from './logos/RS.png';
import logoRT from './logos/RT.png';
import logoRU from './logos/RU.png';
import logoRV from './logos/RV.png';
import logoRX from './logos/RX.png';
import logoRY from './logos/RY.png';
import logoRZ from './logos/RZ.png';
import logoS0 from './logos/S0.png';
import logoS1 from './logos/S1.png';
import logoS2 from './logos/S2.png';
import logoS3 from './logos/S3.png';
import logoS4 from './logos/S4.png';
import logoS5 from './logos/S5.png';
import logoS6 from './logos/S6.png';
import logoS7 from './logos/S7.png';
import logoS8 from './logos/S8.png';
import logoS9 from './logos/S9.png';
import logoSA from './logos/SA.png';
import logoSB from './logos/SB.png';
import logoSC from './logos/SC.png';
import logoSD from './logos/SD.png';
import logoSE from './logos/SE.png';
import logoSF from './logos/SF.png';
import logoSG from './logos/SG.png';
import logoSH from './logos/SH.png';
import logoSI from './logos/SI.png';
import logoSJ from './logos/SJ.png';
import logoSK from './logos/SK.png';
import logoSL from './logos/SL.png';
import logoSM from './logos/SM.png';
import logoSN from './logos/SN.png';
import logoSO from './logos/SO.png';
import logoSP from './logos/SP.png';
import logoSQ from './logos/SQ.png';
import logoSR from './logos/SR.png';
import logoSS from './logos/SS.png';
import logoST from './logos/ST.png';
import logoSU from './logos/SU.png';
import logoSV from './logos/SV.png';
import logoSW from './logos/SW.png';
import logoSX from './logos/SX.png';
import logoSY from './logos/SY.png';
import logoSZ from './logos/SZ.png';
import logoT0 from './logos/T0.png';
import logoT1 from './logos/T1.png';
import logoT2 from './logos/T2.png';
import logoT3 from './logos/T3.png';
import logoT4 from './logos/T4.png';
import logoT5 from './logos/T5.png';
import logoT6 from './logos/T6.png';
import logoT7 from './logos/T7.png';
import logoT8 from './logos/T8.png';
import logoTA from './logos/TA.png';
import logoTB from './logos/TB.png';
import logoTC from './logos/TC.png';
import logoTD from './logos/TD.png';
import logoTE from './logos/TE.png';
import logoTF from './logos/TF.png';
import logoTG from './logos/TG.png';
import logoTH from './logos/TH.png';
import logoTI from './logos/TI.png';
import logoTJ from './logos/TJ.png';
import logoTK from './logos/TK.png';
import logoTL from './logos/TL.png';
import logoTM from './logos/TM.png';
import logoTN from './logos/TN.png';
import logoTO from './logos/TO.png';
import logoTP from './logos/TP.png';
import logoTQ from './logos/TQ.png';
import logoTR from './logos/TR.png';
import logoTS from './logos/TS.png';
import logoTT from './logos/TT.png';
import logoTU from './logos/TU.png';
import logoTV from './logos/TV.png';
import logoTW from './logos/TW.png';
import logoTX from './logos/TX.png';
import logoTY from './logos/TY.png';
import logoTZ from './logos/TZ.png';
import logoU0 from './logos/U0.png';
import logoU2 from './logos/U2.png';
import logoU3 from './logos/U3.png';
import logoU4 from './logos/U4.png';
import logoU5 from './logos/U5.png';
import logoU6 from './logos/U6.png';
import logoU7 from './logos/U7.png';
import logoU8 from './logos/U8.png';
import logoU9 from './logos/U9.png';
import logoUA from './logos/UA.png';
import logoUB from './logos/UB.png';
import logoUC from './logos/UC.png';
import logoUD from './logos/UD.png';
import logoUE from './logos/UE.png';
import logoUF from './logos/UF.png';
import logoUG from './logos/UG.png';
import logoUH from './logos/UH.png';
import logoUI from './logos/UI.png';
import logoUJ from './logos/UJ.png';
import logoUK from './logos/UK.png';
import logoUL from './logos/UL.png';
import logoUM from './logos/UM.png';
import logoUN from './logos/UN.png';
import logoUO from './logos/UO.png';
import logoUP from './logos/UP.png';
import logoUQ from './logos/UQ.png';
import logoUR from './logos/UR.png';
import logoUS from './logos/US.png';
import logoUT from './logos/UT.png';
import logoUU from './logos/UU.png';
import logoUV from './logos/UV.png';
import logoUW from './logos/UW.png';
import logoUX from './logos/UX.png';
import logoUY from './logos/UY.png';
import logoUZ from './logos/UZ.png';
import logoV0 from './logos/V0.png';
import logoV2 from './logos/V2.png';
import logoV3 from './logos/V3.png';
import logoV4 from './logos/V4.png';
import logoV5 from './logos/V5.png';
import logoV6 from './logos/V6.png';
import logoV7 from './logos/V7.png';
import logoV8 from './logos/V8.png';
import logoV9 from './logos/V9.png';
import logoVA from './logos/VA.png';
import logoVB from './logos/VB.png';
import logoVC from './logos/VC.png';
import logoVD from './logos/VD.png';
import logoVE from './logos/VE.png';
import logoVF from './logos/VF.png';
import logoVG from './logos/VG.png';
import logoVH from './logos/VH.png';
import logoVI from './logos/VI.png';
import logoVJ from './logos/VJ.png';
import logoVK from './logos/VK.png';
import logoVL from './logos/VL.png';
import logoVM from './logos/VM.png';
import logoVN from './logos/VN.png';
import logoVO from './logos/VO.png';
import logoVP from './logos/VP.png';
import logoVQ from './logos/VQ.png';
import logoVR from './logos/VR.png';
import logoVS from './logos/VS.png';
import logoVT from './logos/VT.png';
import logoVU from './logos/VU.png';
import logoVV from './logos/VV.png';
import logoVW from './logos/VW.png';
import logoVX from './logos/VX.png';
import logoVY from './logos/VY.png';
import logoVZ from './logos/VZ.png';
import logoW2 from './logos/W2.png';
import logoW3 from './logos/W3.png';
import logoW4 from './logos/W4.png';
import logoW5 from './logos/W5.png';
import logoW6 from './logos/W6.png';
import logoW7 from './logos/W7.png';
import logoW8 from './logos/W8.png';
import logoW9 from './logos/W9.png';
import logoWA from './logos/WA.png';
import logoWB from './logos/WB.png';
import logoWC from './logos/WC.png';
import logoWD from './logos/WD.png';
import logoWE from './logos/WE.png';
import logoWF from './logos/WF.png';
import logoWG from './logos/WG.png';
import logoWH from './logos/WH.png';
import logoWI from './logos/WI.png';
import logoWJ from './logos/WJ.png';
import logoWK from './logos/WK.png';
import logoWL from './logos/WL.png';
import logoWM from './logos/WM.png';
import logoWN from './logos/WN.png';
import logoWO from './logos/WO.png';
import logoWP from './logos/WP.png';
import logoWQ from './logos/WQ.png';
import logoWR from './logos/WR.png';
import logoWS from './logos/WS.png';
import logoWT from './logos/WT.png';
import logoWU from './logos/WU.png';
import logoWV from './logos/WV.png';
import logoWW from './logos/WW.png';
import logoWX from './logos/WX.png';
import logoWY from './logos/WY.png';
import logoWZ from './logos/WZ.png';
import logoX0 from './logos/X0.png';
import logoX1 from './logos/X1.png';
import logoX2 from './logos/X2.png';
import logoX3 from './logos/X3.png';
import logoX4 from './logos/X4.png';
import logoX5 from './logos/X5.png';
import logoX6 from './logos/X6.png';
import logoX7 from './logos/X7.png';
import logoX8 from './logos/X8.png';
import logoX9 from './logos/X9.png';
import logoXA from './logos/XA.png';
import logoXB from './logos/XB.png';
import logoXC from './logos/XC.png';
import logoXD from './logos/XD.png';
import logoXE from './logos/XE.png';
import logoXF from './logos/XF.png';
import logoXG from './logos/XG.png';
import logoXH from './logos/XH.png';
import logoXI from './logos/XI.png';
import logoXJ from './logos/XJ.png';
import logoXK from './logos/XK.png';
import logoXL from './logos/XL.png';
import logoXM from './logos/XM.png';
import logoXN from './logos/XN.png';
import logoXO from './logos/XO.png';
import logoXP from './logos/XP.png';
import logoXQ from './logos/XQ.png';
import logoXR from './logos/XR.png';
import logoXS from './logos/XS.png';
import logoXT from './logos/XT.png';
import logoXU from './logos/XU.png';
import logoXV from './logos/XV.png';
import logoXW from './logos/XW.png';
import logoXX from './logos/XX.png';
import logoXY from './logos/XY.png';
import logoXZ from './logos/XZ.png';
import logoY0 from './logos/Y0.png';
import logoY2 from './logos/Y2.png';
import logoY4 from './logos/Y4.png';
import logoY5 from './logos/Y5.png';
import logoY6 from './logos/Y6.png';
import logoY7 from './logos/Y7.png';
import logoY8 from './logos/Y8.png';
import logoY9 from './logos/Y9.png';
import logoYA from './logos/YA.png';
import logoYB from './logos/YB.png';
import logoYC from './logos/YC.png';
import logoYD from './logos/YD.png';
import logoYE from './logos/YE.png';
import logoYF from './logos/YF.png';
import logoYG from './logos/YG.png';
import logoYH from './logos/YH.png';
import logoYI from './logos/YI.png';
import logoYJ from './logos/YJ.png';
import logoYK from './logos/YK.png';
import logoYL from './logos/YL.png';
import logoYM from './logos/YM.png';
import logoYN from './logos/YN.png';
import logoYO from './logos/YO.png';
import logoYP from './logos/YP.png';
import logoYQ from './logos/YQ.png';
import logoYR from './logos/YR.png';
import logoYS from './logos/YS.png';
import logoYT from './logos/YT.png';
import logoYU from './logos/YU.png';
import logoYV from './logos/YV.png';
import logoYW from './logos/YW.png';
import logoYX from './logos/YX.png';
import logoYZ from './logos/YZ.png';
import logoZ1 from './logos/Z1.png';
import logoZ2 from './logos/Z2.png';
import logoZ3 from './logos/Z3.png';
import logoZ4 from './logos/Z4.png';
import logoZ5 from './logos/Z5.png';
import logoZ6 from './logos/Z6.png';
import logoZ7 from './logos/Z7.png';
import logoZ8 from './logos/Z8.png';
import logoZ9 from './logos/Z9.png';
import logoZA from './logos/ZA.png';
import logoZB from './logos/ZB.png';
import logoZC from './logos/ZC.png';
import logoZD from './logos/ZD.png';
import logoZE from './logos/ZE.png';
import logoZF from './logos/ZF.png';
import logoZG from './logos/ZG.png';
import logoZH from './logos/ZH.png';
import logoZI from './logos/ZI.png';
import logoZJ from './logos/ZJ.png';
import logoZK from './logos/ZK.png';
import logoZL from './logos/ZL.png';
import logoZM from './logos/ZM.png';
import logoZN from './logos/ZN.png';
import logoZO from './logos/ZO.png';
import logoZP from './logos/ZP.png';
import logoZQ from './logos/ZQ.png';
import logoZR from './logos/ZR.png';
import logoZS from './logos/ZS.png';
import logoZT from './logos/ZT.png';
import logoZU from './logos/ZU.png';
import logoZV from './logos/ZV.png';
import logoZW from './logos/ZW.png';
import logoZX from './logos/ZX.png';
import logoZY from './logos/ZY.png';

export default {unkwnown, '0B': logo0B, '0E': logo0E, '0Q': logo0Q, '0V': logo0V, '01': logo01, '1A': logo1A,
    '1B': logo1B, '1C': logo1C, '1D': logo1D, '1E': logo1E, '1F': logo1F, '1G': logo1G, '1H': logo1H, '1I': logo1I,
    '1J': logo1J, '1K': logo1K, '1L': logo1L, '1M': logo1M, '1N': logo1N, '1P': logo1P, '1Q': logo1Q, '1R': logo1R,
    '1S': logo1S, '1T': logo1T, '1U': logo1U, '1X': logo1X, '1Y': logo1Y, '1Z': logo1Z, '02': logo02, '2A': logo2A,
    '2B': logo2B, '2C': logo2C, '2D': logo2D, '2E': logo2E, '2F': logo2F, '2G': logo2G, '2H': logo2H, '2I': logo2I,
    '2J': logo2J, '2K': logo2K, '2L': logo2L, '2M': logo2M, '2N': logo2N, '2O': logo2O, '2P': logo2P, '2Q': logo2Q,
    '2R': logo2R, '2S': logo2S, '2T': logo2T, '2U': logo2U, '2V': logo2V, '2W': logo2W, '2Y': logo2Y, '2Z': logo2Z,
    '3A': logo3A, '3B': logo3B, '3C': logo3C, '3D': logo3D, '3E': logo3E, '3F': logo3F, '3G': logo3G, '3H': logo3H,
    '3I': logo3I, '3J': logo3J, '3K': logo3K, '3L': logo3L, '3M': logo3M, '3N': logo3N, '3O': logo3O, '3P': logo3P,
    '3Q': logo3Q, '3R': logo3R, '3S': logo3S, '3T': logo3T, '3U': logo3U, '3V': logo3V, '3W': logo3W, '3X': logo3X,
    '3Y': logo3Y, '3Z': logo3Z, '04': logo04, '4A': logo4A, '4B': logo4B, '4C': logo4C, '4D': logo4D, '4E': logo4E,
    '4G': logo4G, '4H': logo4H, '4I': logo4I, '4J': logo4J, '4K': logo4K, '4L': logo4L, '4M': logo4M, '4N': logo4N,
    '4O': logo4O, '4P': logo4P, '4Q': logo4Q, '4R': logo4R, '4T': logo4T, '4U': logo4U, '4V': logo4V, '4W': logo4W,
    '4X': logo4X, '4Y': logo4Y, '4Z': logo4Z, '5A': logo5A, '5B': logo5B, '5C': logo5C, '5D': logo5D, '5E': logo5E,
    '5F': logo5F, '5G': logo5G, '5H': logo5H, '5I': logo5I, '5J': logo5J, '5K': logo5K, '5L': logo5L, '5M': logo5M,
    '5N': logo5N, '5O': logo5O, '5P': logo5P, '5Q': logo5Q, '5R': logo5R, '5S': logo5S, '5T': logo5T, '5U': logo5U,
    '5V': logo5V, '5W': logo5W, '5X': logo5X, '5Y': logo5Y, '5Z': logo5Z, '6A': logo6A, '6B': logo6B, '6C': logo6C,
    '6D': logo6D, '6E': logo6E, '6F': logo6F, '6G': logo6G, '6H': logo6H, '6I': logo6I, '6J': logo6J, '6K': logo6K,
    '6L': logo6L, '6M': logo6M, '6N': logo6N, '6O': logo6O, '6P': logo6P, '6Q': logo6Q, '6R': logo6R, '6S': logo6S,
    '6T': logo6T, '6U': logo6U, '6V': logo6V, '6W': logo6W, '6X': logo6X, '6Y': logo6Y, '6Z': logo6Z, '7A': logo7A,
    '7B': logo7B, '7C': logo7C, '7D': logo7D, '7E': logo7E, '7F': logo7F, '7G': logo7G, '7H': logo7H, '7I': logo7I,
    '7J': logo7J, '7K': logo7K, '7L': logo7L, '7M': logo7M, '7N': logo7N, '7O': logo7O, '7P': logo7P, '7Q': logo7Q,
    '7R': logo7R, '7T': logo7T, '7U': logo7U, '7V': logo7V, '7W': logo7W, '7Y': logo7Y, '7Z': logo7Z, '8A': logo8A,
    '8B': logo8B, '8C': logo8C, '8D': logo8D, '8E': logo8E, '8F': logo8F, '8G': logo8G, '8H': logo8H, '8I': logo8I,
    '8J': logo8J, '8K': logo8K, '8L': logo8L, '8M': logo8M, '8N': logo8N, '8O': logo8O, '8P': logo8P, '8Q': logo8Q,
    '8R': logo8R, '8S': logo8S, '8T': logo8T, '8U': logo8U, '8V': logo8V, '8W': logo8W, '8Y': logo8Y, '8Z': logo8Z,
    '9A': logo9A, '9B': logo9B, '9C': logo9C, '9D': logo9D, '9E': logo9E, '9F': logo9F, '9G': logo9G, '9H': logo9H,
    '9I': logo9I, '9J': logo9J, '9K': logo9K, '9L': logo9L, '9M': logo9M, '9N': logo9N, '9O': logo9O, '9P': logo9P,
    '9Q': logo9Q, '9R': logo9R, '9S': logo9S, '9T': logo9T, '9U': logo9U, '9V': logo9V, '9W': logo9W, '9X': logo9X,
    '9Y': logo9Y, A0: logoA0, A1: logoA1, A2: logoA2, A3: logoA3, A4: logoA4, A5: logoA5, A6: logoA6, A7: logoA7,
    A8: logoA8, A9: logoA9, AA: logoAA, AB: logoAB, AC: logoAC, AD: logoAD, AE: logoAE, AF: logoAF, AG: logoAG,
    AH: logoAH, AI: logoAI, AJ: logoAJ, AK: logoAK, AL: logoAL, AM: logoAM, AN: logoAN, AO: logoAO, AP: logoAP,
    AQ: logoAQ, AR: logoAR, AS: logoAS, AT: logoAT, AU: logoAU, AV: logoAV, AW: logoAW, AX: logoAX, AY: logoAY,
    AZ: logoAZ, B0: logoB0, B2: logoB2, B3: logoB3, B4: logoB4, B5: logoB5, B6: logoB6, B7: logoB7, B8: logoB8,
    B9: logoB9, BA: logoBA, BB: logoBB, BC: logoBC, BD: logoBD, BE: logoBE, BF: logoBF, BG: logoBG, BH: logoBH,
    BI: logoBI, BJ: logoBJ, BK: logoBK, BL: logoBL, BM: logoBM, BN: logoBN, BO: logoBO, BP: logoBP, BQ: logoBQ,
    BR: logoBR, BS: logoBS, BT: logoBT, BU: logoBU, BV: logoBV, BW: logoBW, BX: logoBX, BY: logoBY, BZ: logoBZ,
    C0: logoC0, C2: logoC2, C3: logoC3, C4: logoC4, C5: logoC5, C6: logoC6, C7: logoC7, C8: logoC8, C9: logoC9,
    CA: logoCA, CB: logoCB, CC: logoCC, CD: logoCD, CE: logoCE, CF: logoCF, CG: logoCG, CH: logoCH, CI: logoCI,
    CJ: logoCJ, CK: logoCK, CL: logoCL, CM: logoCM, CN: logoCN, CO: logoCO, CP: logoCP, CQ: logoCQ, CR: logoCR,
    CS: logoCS, CT: logoCT, CU: logoCU, CV: logoCV, CW: logoCW, CX: logoCX, CY: logoCY, CZ: logoCZ, D0: logoD0,
    D1: logoD1, D2: logoD2, D3: logoD3, D4: logoD4, D5: logoD5, D6: logoD6, D7: logoD7, D8: logoD8, D9: logoD9,
    DA: logoDA, DB: logoDB, DC: logoDC, DD: logoDD, DE: logoDE, DF: logoDF, DG: logoDG, DH: logoDH, DI: logoDI,
    DJ: logoDJ, DK: logoDK, DL: logoDL, DM: logoDM, DN: logoDN, DO: logoDO, DP: logoDP, DQ: logoDQ, DR: logoDR,
    DS: logoDS, DT: logoDT, DU: logoDU, DV: logoDV, DW: logoDW, DX: logoDX, DY: logoDY, DZ: logoDZ, E0: logoE0,
    E2: logoE2, E3: logoE3, E4: logoE4, E5: logoE5, E6: logoE6, E7: logoE7, E8: logoE8, E9: logoE9, EA: logoEA,
    EB: logoEB, EC: logoEC, ED: logoED, EE: logoEE, EF: logoEF, EG: logoEG, EH: logoEH, EI: logoEI, EJ: logoEJ,
    EK: logoEK, EL: logoEL, EM: logoEM, EN: logoEN, EO: logoEO, EP: logoEP, EQ: logoEQ, ER: logoER, ES: logoES,
    ET: logoET, EU: logoEU, EV: logoEV, EW: logoEW, EX: logoEX, EY: logoEY, EZ: logoEZ, F2: logoF2, F3: logoF3,
    F4: logoF4, F5: logoF5, F6: logoF6, F7: logoF7, F8: logoF8, F9: logoF9, FA: logoFA, FB: logoFB, FC: logoFC,
    FD: logoFD, FE: logoFE, FG: logoFG, FH: logoFH, FI: logoFI, FJ: logoFJ, FK: logoFK, FL: logoFL, FM: logoFM,
    FN: logoFN, FO: logoFO, FP: logoFP, FQ: logoFQ, FR: logoFR, FS: logoFS, FT: logoFT, FU: logoFU, FV: logoFV,
    FW: logoFW, FX: logoFX, FY: logoFY, FZ: logoFZ, G0: logoG0, G1: logoG1, G2: logoG2, G3: logoG3, G4: logoG4,
    G5: logoG5, G6: logoG6, G7: logoG7, G8: logoG8, G9: logoG9, GA: logoGA, GB: logoGB, GC: logoGC, GD: logoGD,
    GE: logoGE, GF: logoGF, GG: logoGG, GH: logoGH, GI: logoGI, GJ: logoGJ, GK: logoGK, GL: logoGL, GM: logoGM,
    GN: logoGN, GO: logoGO, GP: logoGP, GQ: logoGQ, GR: logoGR, GS: logoGS, GT: logoGT, GU: logoGU, GV: logoGV,
    GW: logoGW, GX: logoGX, GY: logoGY, GZ: logoGZ, H1: logoH1, H2: logoH2, H3: logoH3, H4: logoH4, H5: logoH5,
    H6: logoH6, H7: logoH7, H8: logoH8, H9: logoH9, HA: logoHA, HB: logoHB, HC: logoHC, HD: logoHD, HE: logoHE,
    HF: logoHF, HG: logoHG, HH: logoHH, HI: logoHI, HJ: logoHJ, HK: logoHK, HM: logoHM, HN: logoHN, HO: logoHO,
    HP: logoHP, HQ: logoHQ, HR: logoHR, HS: logoHS, HT: logoHT, HU: logoHU, HV: logoHV, HW: logoHW, HX: logoHX,
    HY: logoHY, HZ: logoHZ, I1: logoI1, I2: logoI2, I3: logoI3, I4: logoI4, I5: logoI5, I6: logoI6, I7: logoI7,
    I8: logoI8, I9: logoI9, IA: logoIA, IB: logoIB, IC: logoIC, ID: logoID, IE: logoIE, IF: logoIF, IG: logoIG,
    IH: logoIH, II: logoII, IJ: logoIJ, IK: logoIK, IL: logoIL, IM: logoIM, IN: logoIN, IO: logoIO, IP: logoIP,
    IQ: logoIQ, IR: logoIR, IS: logoIS, IT: logoIT, IU: logoIU, IV: logoIV, IW: logoIW, IX: logoIX, IY: logoIY,
    IZ: logoIZ, J0: logoJ0, J1: logoJ1, J2: logoJ2, J3: logoJ3, J4: logoJ4, J5: logoJ5, J6: logoJ6, J7: logoJ7,
    J8: logoJ8, J9: logoJ9, JA: logoJA, JB: logoJB, JC: logoJC, JD: logoJD, JE: logoJE, JF: logoJF, JG: logoJG,
    JH: logoJH, JI: logoJI, JJ: logoJJ, JK: logoJK, JL: logoJL, JM: logoJM, JN: logoJN, JO: logoJO, JP: logoJP,
    JQ: logoJQ, JR: logoJR, JS: logoJS, JT: logoJT, JU: logoJU, JV: logoJV, JW: logoJW, JX: logoJX, JY: logoJY,
    JZ: logoJZ, K1: logoK1, K2: logoK2, K3: logoK3, K4: logoK4, K5: logoK5, K6: logoK6, K7: logoK7, K8: logoK8,
    K9: logoK9, KA: logoKA, KB: logoKB, KC: logoKC, KD: logoKD, KE: logoKE, KF: logoKF, KG: logoKG, KH: logoKH,
    KI: logoKI, KJ: logoKJ, KK: logoKK, KL: logoKL, KM: logoKM, KN: logoKN, KO: logoKO, KP: logoKP, KQ: logoKQ,
    KR: logoKR, KS: logoKS, KT: logoKT, KU: logoKU, KV: logoKV, KW: logoKW, KX: logoKX, KY: logoKY, KZ: logoKZ,
    L2: logoL2, L3: logoL3, L4: logoL4, L5: logoL5, L6: logoL6, L7: logoL7, L8: logoL8, L9: logoL9, LA: logoLA,
    LB: logoLB, LC: logoLC, LD: logoLD, LE: logoLE, LF: logoLF, LG: logoLG, LH: logoLH, LI: logoLI, LJ: logoLJ,
    LK: logoLK, LL: logoLL, LM: logoLM, LN: logoLN, LO: logoLO, LP: logoLP, LQ: logoLQ, LR: logoLR, LS: logoLS,
    LT: logoLT, LU: logoLU, LV: logoLV, LW: logoLW, LX: logoLX, LY: logoLY, LZ: logoLZ, M0: logoM0, M2: logoM2,
    M3: logoM3, M4: logoM4, M5: logoM5, M6: logoM6, M7: logoM7, M8: logoM8, M9: logoM9, MA: logoMA, MB: logoMB,
    MC: logoMC, MD: logoMD, ME: logoME, MF: logoMF, MG: logoMG, MH: logoMH, MI: logoMI, MJ: logoMJ, MK: logoMK,
    ML: logoML, MM: logoMM, MN: logoMN, MO: logoMO, MP: logoMP, MQ: logoMQ, MR: logoMR, MS: logoMS, MT: logoMT,
    MU: logoMU, MV: logoMV, MW: logoMW, MX: logoMX, MY: logoMY, MZ: logoMZ, N2: logoN2, N3: logoN3, N4: logoN4,
    N5: logoN5, N6: logoN6, N7: logoN7, N8: logoN8, N9: logoN9, NA: logoNA, NB: logoNB, NC: logoNC, NE: logoNE,
    NF: logoNF, NG: logoNG, NH: logoNH, NI: logoNI, NK: logoNK, NL: logoNL, NM: logoNM, NN: logoNN, NO: logoNO,
    NP: logoNP, NQ: logoNQ, NR: logoNR, NS: logoNS, NT: logoNT, NU: logoNU, NV: logoNV, NW: logoNW, NX: logoNX,
    NY: logoNY, NZ: logoNZ, O2: logoO2, O3: logoO3, O4: logoO4, O5: logoO5, O6: logoO6, O7: logoO7, O8: logoO8,
    O9: logoO9, OA: logoOA, OB: logoOB, OC: logoOC, OD: logoOD, OE: logoOE, OF: logoOF, OG: logoOG, OH: logoOH,
    OI: logoOI, OJ: logoOJ, OK: logoOK, OL: logoOL, OM: logoOM, ON: logoON, OO: logoOO, OP: logoOP, OQ: logoOQ,
    OR: logoOR, OS: logoOS, OT: logoOT, OU: logoOU, OV: logoOV, OW: logoOW, OX: logoOX, OY: logoOY, OZ: logoOZ,
    P0: logoP0, P1: logoP1, P2: logoP2, P3: logoP3, P4: logoP4, P5: logoP5, P6: logoP6, P7: logoP7, P8: logoP8,
    P9: logoP9, PA: logoPA, PB: logoPB, PC: logoPC, PD: logoPD, PE: logoPE, PF: logoPF, PG: logoPG, PH: logoPH,
    PI: logoPI, PJ: logoPJ, PK: logoPK, PL: logoPL, PM: logoPM, PN: logoPN, PO: logoPO, PP: logoPP, PQ: logoPQ,
    PR: logoPR, PS: logoPS, PT: logoPT, PU: logoPU, PV: logoPV, PW: logoPW, PX: logoPX, PY: logoPY, PZ: logoPZ,
    Q0: logoQ0, Q2: logoQ2, Q3: logoQ3, Q4: logoQ4, Q5: logoQ5, Q6: logoQ6, Q7: logoQ7, Q8: logoQ8, Q9: logoQ9,
    QA: logoQA, QB: logoQB, QC: logoQC, QD: logoQD, QE: logoQE, QF: logoQF, QG: logoQG, QH: logoQH, QI: logoQI,
    QJ: logoQJ, QK: logoQK, QL: logoQL, QM: logoQM, QN: logoQN, QO: logoQO, QP: logoQP, QQ: logoQQ, QR: logoQR,
    QS: logoQS, QT: logoQT, QU: logoQU, QV: logoQV, QW: logoQW, QX: logoQX, QY: logoQY, QZ: logoQZ, R0: logoR0,
    R1: logoR1, R2: logoR2, R3: logoR3, R4: logoR4, R5: logoR5, R6: logoR6, R7: logoR7, R8: logoR8, R9: logoR9,
    RA: logoRA, RB: logoRB, RC: logoRC, RD: logoRD, RE: logoRE, RF: logoRF, RG: logoRG, RH: logoRH, RI: logoRI,
    RJ: logoRJ, RK: logoRK, RL: logoRL, RN: logoRN, RO: logoRO, RP: logoRP, RQ: logoRQ, RR: logoRR, RS: logoRS,
    RT: logoRT, RU: logoRU, RV: logoRV, RX: logoRX, RY: logoRY, RZ: logoRZ, S0: logoS0, S1: logoS1, S2: logoS2,
    S3: logoS3, S4: logoS4, S5: logoS5, S6: logoS6, S7: logoS7, S8: logoS8, S9: logoS9, SA: logoSA, SB: logoSB,
    SC: logoSC, SD: logoSD, SE: logoSE, SF: logoSF, SG: logoSG, SH: logoSH, SI: logoSI, SJ: logoSJ, SK: logoSK,
    SL: logoSL, SM: logoSM, SN: logoSN, SO: logoSO, SP: logoSP, SQ: logoSQ, SR: logoSR, SS: logoSS, ST: logoST,
    SU: logoSU, SV: logoSV, SW: logoSW, SX: logoSX, SY: logoSY, SZ: logoSZ, T0: logoT0, T1: logoT1, T2: logoT2,
    T3: logoT3, T4: logoT4, T5: logoT5, T6: logoT6, T7: logoT7, T8: logoT8, TA: logoTA, TB: logoTB, TC: logoTC,
    TD: logoTD, TE: logoTE, TF: logoTF, TG: logoTG, TH: logoTH, TI: logoTI, TJ: logoTJ, TK: logoTK, TL: logoTL,
    TM: logoTM, TN: logoTN, TO: logoTO, TP: logoTP, TQ: logoTQ, TR: logoTR, TS: logoTS, TT: logoTT, TU: logoTU,
    TV: logoTV, TW: logoTW, TX: logoTX, TY: logoTY, TZ: logoTZ, U0: logoU0, U2: logoU2, U3: logoU3, U4: logoU4,
    U5: logoU5, U6: logoU6, U7: logoU7, U8: logoU8, U9: logoU9, UA: logoUA, UB: logoUB, UC: logoUC, UD: logoUD,
    UE: logoUE, UF: logoUF, UG: logoUG, UH: logoUH, UI: logoUI, UJ: logoUJ, UK: logoUK, UL: logoUL, UM: logoUM,
    UN: logoUN, UO: logoUO, UP: logoUP, UQ: logoUQ, UR: logoUR, US: logoUS, UT: logoUT, UU: logoUU, UV: logoUV,
    UW: logoUW, UX: logoUX, UY: logoUY, UZ: logoUZ, V0: logoV0, V2: logoV2, V3: logoV3, V4: logoV4, V5: logoV5,
    V6: logoV6, V7: logoV7, V8: logoV8, V9: logoV9, VA: logoVA, VB: logoVB, VC: logoVC, VD: logoVD, VE: logoVE,
    VF: logoVF, VG: logoVG, VH: logoVH, VI: logoVI, VJ: logoVJ, VK: logoVK, VL: logoVL, VM: logoVM, VN: logoVN,
    VO: logoVO, VP: logoVP, VQ: logoVQ, VR: logoVR, VS: logoVS, VT: logoVT, VU: logoVU, VV: logoVV, VW: logoVW,
    VX: logoVX, VY: logoVY, VZ: logoVZ, W2: logoW2, W3: logoW3, W4: logoW4, W5: logoW5, W6: logoW6, W7: logoW7,
    W8: logoW8, W9: logoW9, WA: logoWA, WB: logoWB, WC: logoWC, WD: logoWD, WE: logoWE, WF: logoWF, WG: logoWG,
    WH: logoWH, WI: logoWI, WJ: logoWJ, WK: logoWK, WL: logoWL, WM: logoWM, WN: logoWN, WO: logoWO, WP: logoWP,
    WQ: logoWQ, WR: logoWR, WS: logoWS, WT: logoWT, WU: logoWU, WV: logoWV, WW: logoWW, WX: logoWX, WY: logoWY,
    WZ: logoWZ, X0: logoX0, X1: logoX1, X2: logoX2, X3: logoX3, X4: logoX4, X5: logoX5, X6: logoX6, X7: logoX7,
    X8: logoX8, X9: logoX9, XA: logoXA, XB: logoXB, XC: logoXC, XD: logoXD, XE: logoXE, XF: logoXF, XG: logoXG,
    XH: logoXH, XI: logoXI, XJ: logoXJ, XK: logoXK, XL: logoXL, XM: logoXM, XN: logoXN, XO: logoXO, XP: logoXP,
    XQ: logoXQ, XR: logoXR, XS: logoXS, XT: logoXT, XU: logoXU, XV: logoXV, XW: logoXW, XX: logoXX, XY: logoXY,
    XZ: logoXZ, Y0: logoY0, Y2: logoY2, Y4: logoY4, Y5: logoY5, Y6: logoY6, Y7: logoY7, Y8: logoY8, Y9: logoY9,
    YA: logoYA, YB: logoYB, YC: logoYC, YD: logoYD, YE: logoYE, YF: logoYF, YG: logoYG, YH: logoYH, YI: logoYI,
    YJ: logoYJ, YK: logoYK, YL: logoYL, YM: logoYM, YN: logoYN, YO: logoYO, YP: logoYP, YQ: logoYQ, YR: logoYR,
    YS: logoYS, YT: logoYT, YU: logoYU, YV: logoYV, YW: logoYW, YX: logoYX, YZ: logoYZ, Z1: logoZ1, Z2: logoZ2,
    Z3: logoZ3, Z4: logoZ4, Z5: logoZ5, Z6: logoZ6, Z7: logoZ7, Z8: logoZ8, Z9: logoZ9, ZA: logoZA, ZB: logoZB,
    ZC: logoZC, ZD: logoZD, ZE: logoZE, ZF: logoZF, ZG: logoZG, ZH: logoZH, ZI: logoZI, ZJ: logoZJ, ZK: logoZK,
    ZL: logoZL, ZM: logoZM, ZN: logoZN, ZO: logoZO, ZP: logoZP, ZQ: logoZQ, ZR: logoZR, ZS: logoZS, ZT: logoZT,
    ZU: logoZU, ZV: logoZV, ZW: logoZW, ZX: logoZX, ZY: logoZY,
};



// WEBPACK FOOTER //
// ./src/app/modules/flights/assets/logos.js